/* eslint-disable jsx-a11y/anchor-is-valid */
import Header from "../pages/header";
import Footer from "../pages/footer";
import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom"; // 1. Import useParams
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// 2. Import update and get functions
import { updateJob, getJob } from "../../services/jobs";
import { categories, jobsTypes } from "../data/job_data";

const UpdateJob = () => {
  const { id } = useParams(); // 3. Get ID from URL
  const navigate = useNavigate(); // Optional: to redirect after success

  const [inputs, setInputs] = useState({});
  const [logoPreview, setLogoPreview] = useState(null); // State for image preview
  const [getError, setErrors] = useState({ message: "", type: "" });
  const messageRef = useRef(null);

  // 4. Fetch Data on Component Mount
  useEffect(() => {
    const fetchJobData = async () => {
      if (!id) return;
      try {
        const response = await getJob(id).then((res) => res.json());
        // Assuming response.data contains the job object
        // Adjust 'response.data' based on your actual API structure
        const jobData = (await response.data) || response;

        setInputs(jobData);

        // If there is an existing logo URL, set it to preview
        if (jobData.company_logo) {
          setLogoPreview(jobData.company_logo);
        }
      } catch (error) {
        setErrors({ message: "Failed to load job details", type: "error" });
      }
    };

    fetchJobData();
  }, [id]);

  // Scroll to error/success message
  useEffect(() => {
    if (getError.message && messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [getError]);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // 5. Special Handler for File Upload (Logo)
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Set the file object for the API
      setInputs((prev) => ({ ...prev, company_logo: file }));
      // Set the local preview URL
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   console.log("Updating job with data:", inputs);

  //   // 6. Call Update Function instead of Create
  //   // Note: You might need to use FormData if sending files
  //   const response = await updateJob(id, inputs);

  //   if (
  //     response.status === 200 ||
  //     response.status === 201 ||
  //     response.success
  //   ) {
  //     setErrors({ message: "Job Updated Successfully!", type: "success" });
  //     // Optional: Redirect after 2 seconds
  //     // setTimeout(() => navigate('/jobs'), 2000);
  //   } else {
  //     setErrors({
  //       message: response.statusText || "Something Went Wrong!",
  //       type: "error",
  //     });
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // 1. Create a new FormData object
    const formData = new FormData();

    // 2. Loop through your inputs state and append to formData
    Object.keys(inputs).forEach((key) => {
      // Special check:
      // If the logo is still a string (existing URL from DB), don't send it again
      // Only send it if it is a 'File' object (a new upload)
      if (key === "company_logo") {
        if (inputs[key] instanceof File) {
          formData.append(key, inputs[key]);
        }
      } else {
        // Append all other text fields
        formData.append(key, inputs[key]);
      }
    });

    // 3. Send formData instead of 'inputs'
    const response = await updateJob(id, formData);

    if (
      response.status === 200 ||
      response.status === 201 ||
      response.success ||
      response.message === "Updated"
    ) {
      setErrors({ message: "Job Updated Successfully!", type: "success" });
    } else {
      setErrors({ message: "Something Went Wrong!", type: "error" });
    }
  };

  // React Quill Handlers
  const handleResponsibilityChange = (value) => {
    setInputs((prev) => ({ ...prev, responsibility: value }));
  };

  const handleQualificationsChange = (value) => {
    setInputs((prev) => ({ ...prev, qualifications: value }));
  };

  const handleDescriptionChange = (value) => {
    setInputs((prev) => ({ ...prev, description: value }));
  };

  console.log("Current Inputs State:", inputs);
  return (
    <div>
      <div className="container-fluid bg-white p-0">
        <Header path="job_details"></Header>
        <div className="container-fluid py-5 bg-dark page-header mb-5">
          <div className="container my-5 pt-5 pb-4">
            <h1 className="display-3 text-white mb-3 animated slideInDown">
              Edit {inputs.title} Job
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb text-uppercase">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item text-white active"
                  aria-current="page"
                >
                  Update 
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="container">
            <div className="row gy-5 gx-4">
              <div className="col-lg-8">
                <div
                  ref={messageRef}
                  className={`p-3 mb-3 rounded ${
                    getError.type === "success"
                      ? "bg-success text-white"
                      : getError.type === "error"
                      ? "bg-danger text-white"
                      : ""
                  }`}
                  style={{ display: getError.message ? "block" : "none" }}
                >
                  {getError.message}
                </div>
                <div>
                  <h4 className="mb-4">Edit Job Details</h4>
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12 col-sm-6">
                        <select
                          // Use value controlled by state
                          value={inputs.category || ""}
                          className="form-control"
                          name="category"
                          onChange={handleChange}
                        >
                          <option value="">Select Job Category</option>
                          {categories.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Title"
                          name="title"
                          value={inputs.title || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6">
                        <select
                          value={inputs.job_type || ""}
                          className="form-control"
                          name="job_type"
                          onChange={handleChange}
                        >
                          <option value="">Select Job Type</option>
                          {jobsTypes.map((type) => (
                            <option key={type.id} value={type.label}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Role"
                          name="role"
                          value={inputs.role || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Location"
                          name="location"
                          value={inputs.location || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Job Salary"
                          name="salary"
                          value={inputs.salary || ""}
                          onChange={handleChange}
                        />
                      </div>

                      {/* --- FIXED LOGO UPLOAD SECTION --- */}
                      {/* <div className="col-12 col-sm-6">
                        <label className="form-label fw-bold">
                          Company Logo
                        </label>
                        <div className="d-flex align-items-center gap-3">
                          {logoPreview && (
                            <img
                              src={logoPreview}
                              alt="Preview"
                              className="rounded border"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          <input
                            type="file"
                            className="form-control bg-white"
                            name="company_logo"
                            accept="image/*"
                            // REMOVED: value={inputs.company_logo} (This causes crash)
                            onChange={handleLogoChange}
                          />
                        </div>
                      </div> */}
                      {/* --------------------------------- */}

                      <div className="col-12">
                        <label className="form-label">Job Responsibility</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.responsibility || ""}
                          onChange={handleResponsibilityChange}
                          className="bg-white"
                          style={{ height: "200px", marginBottom: "50px" }}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label">Job Qualifications</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.qualifications || ""}
                          onChange={handleQualificationsChange}
                          className="bg-white"
                          style={{ height: "200px", marginBottom: "50px" }}
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label">Job Description</label>
                        <ReactQuill
                          theme="snow"
                          value={inputs.description || ""}
                          onChange={handleDescriptionChange}
                          className="bg-white"
                          style={{ height: "200px", marginBottom: "50px" }}
                        />
                      </div>
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Update Job
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Sidebar Summary (Dynamic) */}
              <div className="col-lg-4">
                <div className="bg-light rounded p-5 mb-4 wow slideInUp">
                  <h4 className="mb-4">Job Summary</h4>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Job Nature: {inputs.job_type || "N/A"}
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Salary: {inputs.salary || "N/A"}
                  </p>
                  <p>
                    <i className="fa fa-angle-right text-primary me-2" />
                    Location: {inputs.location || "N/A"}
                  </p>
                </div>
                <div className="bg-light rounded p-5 wow slideInUp">
                  <h4 className="mb-4">Company Detail</h4>
                  <p className="m-0">
                    Details regarding the company will appear here.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
        <a
          href="#"
          className="btn btn-lg btn-primary btn-lg-square back-to-top"
        >
          <i className="bi bi-arrow-up" />
        </a>
      </div>
    </div>
  );
};

export default UpdateJob;
